import React from 'react';

export const Message = ({ width = '14', height = '14', fillOpacity = '1' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.68023 10.1988L1.89937 13.2232C1.37555 13.6422 0.599609 13.2693 0.599609 12.5985V2.99975C0.599609 1.67439 1.67413 0.599976 2.99961 0.599976H10.9996C12.3251 0.599976 13.3996 1.67439 13.3996 2.99975V7.799C13.3996 9.12436 12.3251 10.1988 10.9996 10.1988H5.68023ZM2.19922 10.9342L4.89946 8.77422C5.04131 8.66075 5.21756 8.59893 5.39922 8.59893H10.9992C11.441 8.59893 11.7992 8.24079 11.7992 7.799V2.99975C11.7992 2.55797 11.441 2.19983 10.9992 2.19983H2.99922C2.55739 2.19983 2.19922 2.55797 2.19922 2.99975V10.9342Z"
        fill="white"
        fillOpacity={fillOpacity}
      />
    </svg>
  );
};
